export default __webpack_public_path__ + "static/media/Shopping-Cart.77bfb5fc.jpg";